import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import SignOutButton from "./SignOutButton";
import { useRef, useState, useEffect } from "react";

const Header = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      // If not on the homepage, navigate to home with hash
      if (location.pathname !== "/") {
        window.location.href = `/#${id}`;
      }
    }
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    if (!mobileMenuOpen) return;
    function handleClick(e) {
      if (
        (menuRef.current && menuRef.current.contains(e.target)) ||
        (hamburgerRef.current && hamburgerRef.current.contains(e.target))
      ) {
        return;
      }
      setMobileMenuOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [mobileMenuOpen]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-primary no-underline text-left">White Curve</Link>
          </div>
          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-sm font-medium text-gray-700 hover:text-primary transition-colors no-underline" onClick={e => handleNavClick(e, "features")}>Features</a>
            <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-primary transition-colors no-underline" onClick={e => handleNavClick(e, "how-it-works")}>How it Works</a>
            {currentUser ? (
              <>
                <Link to="/app" className="no-underline">
                  <Button size="sm" className="bg-primary hover:bg-primary/90 text-white px-3 py-1">Dashboard</Button>
                </Link>
                <SignOutButton size="sm" />
              </>
            ) : (
              <>
                <Link to="/signin" className="no-underline">
                  <Button size="sm" variant="outline" className="px-3 py-1">Sign In</Button>
                </Link>
              </>
            )}
          </div>
          {/* Hamburger for Mobile */}
          <button
            ref={hamburgerRef}
            className="md:hidden absolute top-4 right-4 flex items-center justify-center p-0 w-8 h-8 rounded focus:outline-none focus:ring-2 focus:ring-primary z-50"
            aria-label="Open menu"
            onClick={e => {
              e.stopPropagation();
              setMobileMenuOpen(open => !open);
            }}
            style={{ boxSizing: 'content-box' }}
          >
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        {/* Mobile Dropdown Menu */}
        {mobileMenuOpen && (
          <div ref={menuRef} className="md:hidden absolute right-4 top-16 mt-0 bg-white shadow-lg rounded-lg py-4 px-6 flex flex-col gap-4 animate-fade-in z-40 w-48">
            <a href="#features" className="text-base font-medium text-gray-700 hover:text-primary transition-colors no-underline" onClick={e => handleNavClick(e, "features")}>Features</a>
            <a href="#how-it-works" className="text-base font-medium text-gray-700 hover:text-primary transition-colors no-underline" onClick={e => handleNavClick(e, "how-it-works")}>How it Works</a>
            {currentUser ? (
              <>
                <Link to="/app" className="no-underline" onClick={() => setMobileMenuOpen(false)}>
                  <Button size="sm" className="bg-primary hover:bg-primary/90 text-white px-3 py-1 w-full">Dashboard</Button>
                </Link>
                <SignOutButton size="sm" onClick={() => setMobileMenuOpen(false)} />
              </>
            ) : (
              <>
                <Link to="/signin" className="no-underline" onClick={() => setMobileMenuOpen(false)}>
                  <Button size="sm" variant="outline" className="px-3 py-1 w-full">Sign In</Button>
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header; 